import React from 'react'
import PT from 'prop-types'
import Icon from '@vimcar/shared-components/components/Icon'

import colors from '#styles/colors'
import styles from './styles.css'

const Warning = ({ color, icon, text, title }) => (
  <div className={styles.warning}>
    <Icon
      className={styles.warningIcon}
      fill={color}
      icon={icon}
      size={40}
      />
    <h2>{title}</h2>
    <p className={styles.warningText}>{text}</p>
  </div>
)

Warning.propTypes = {
  color: PT.string,
  icon: PT.string,
  text: PT.string.isRequired,
  title: PT.string.isRequired,
}

Warning.defaultProps = {
  icon: 'warning',
  color: colors.colorDarkGreyLight,
}

export default Warning
